import React, { Fragment } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
const PROGRESSION = ['Traffic', 'Engagement', 'High Value Actions', 'Adoption'];
export function TitleSlide() {
  const reduceMotion = useReducedMotion();
  return <div className="relative h-full w-full overflow-hidden bg-black font-sans" data-id="element-240" data-mp="gaswee68xo8k">
      <div className="absolute inset-0" data-id="element-241" data-mp="c9pdtjwtde3n">
        <motion.img src="https://cdn.magicpatterns.com/patterns/generated-images/74813745-7e86-420a-bfa0-591d985a51d4.jpg" alt="Healthcare professional reviewing digital content in a dermatology clinic" className="h-full w-full object-cover" initial={reduceMotion ? false : {
        scale: 1.06
      }} animate={{
        scale: 1
      }} transition={{
        duration: 9,
        ease: 'easeOut'
      }} data-id="element-242" data-mp="c8xvhas89cvb" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/70 to-black/30" data-id="element-243" data-mp="1rs10szgw74cq" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-transparent to-black/40" data-id="element-244" data-mp="1npe5gol0j1as" />
      </div>

      <div className="absolute left-0 right-0 top-0 z-20 h-1 bg-[var(--brand-green)]" data-id="element-245" data-mp="vq7gkazzwqc2" />

      <div className="relative z-10 flex h-full flex-col justify-center px-[clamp(2rem,6vw,6rem)] pb-[clamp(5rem,9vh,7rem)] pt-[clamp(2rem,4vw,4rem)]" data-id="element-246" data-mp="10qlqjyl5qacq">
        <div className="max-w-5xl" data-id="element-247" data-mp="msnfb224uu1g">
          <div className="mb-[clamp(1.25rem,2.5vw,2rem)] flex items-center gap-4" data-id="element-248" data-mp="qrmee616nwkz">
            <span className="h-px w-10 bg-[var(--brand-green-lighter)]" data-id="element-249" data-mp="1ehqgg8yq3o9v" />
            <p className="text-[clamp(0.85rem,1.3vw,1.1rem)] font-semibold uppercase tracking-[0.25em] text-[var(--brand-green-lighter)]" data-id="element-250" data-mp="1ejthrp5bt3tw">
              Snakker Proposal&nbsp;&nbsp;|&nbsp;&nbsp;LEO Pharma
            </p>
          </div>

          <h1 className="mb-[clamp(1.25rem,2.5vw,2rem)] text-[clamp(2.75rem,6.5vw,6rem)] font-bold leading-[0.98] tracking-tight text-white" data-id="element-251" data-mp="19qi8lhd1kayt">
            Shaping the Snakker
            <br data-id="element-252" data-mp="1xerok2nkq4i1" />
            <span className="text-[var(--brand-green-lighter)]" data-id="element-253" data-mp="2272qtc5se2dr">Pilot</span> for
            LEO Pharma
          </h1>

          <p className="mb-[clamp(1.75rem,3vw,2.5rem)] max-w-2xl text-[clamp(1.1rem,1.7vw,1.5rem)] font-medium leading-snug text-white/85" data-id="element-254" data-mp="2c3l2hgdcoz2y">
            Aligning our operating model with your strategy, your tech stack and
            the realities of 2026 budgets.
          </p>

          <div className="inline-flex flex-wrap items-center gap-x-3 gap-y-2 rounded-full border border-white/15 bg-white/[0.07] px-[clamp(1rem,2vw,1.75rem)] py-[clamp(0.65rem,1.2vw,1rem)] backdrop-blur-md" data-id="element-255" data-mp="1y3scjn9nemw1">
            {PROGRESSION.map((step, i) => <Fragment key={step} data-id="element-256" data-mp="1ocfluyzl62rl" data-mpi={i}>
                <span className="text-[clamp(0.8rem,1.2vw,1.05rem)] font-semibold text-white" data-id="element-257" data-mp="1kc57oz1n461n">
                  {step}
                </span>
                {i < PROGRESSION.length - 1 && <span className="text-lg leading-none text-[var(--brand-green-lighter)]" data-id="element-258" data-mp="1ady19a4z96dw">
                    &rarr;
                  </span>}
              </Fragment>)}
          </div>
        </div>
      </div>

      <div className="absolute bottom-[clamp(1.5rem,3vh,2.5rem)] left-[clamp(2rem,6vw,6rem)] right-[clamp(2rem,6vw,6rem)] z-10 hidden md:block" data-id="element-259" data-mp="v9wd3fqfu4kp">
        <p className="max-w-xl border-l-2 border-[var(--brand-green)] pl-4 text-[clamp(0.95rem,1.4vw,1.2rem)] font-medium text-white/70" data-id="element-260" data-mp="10bu2ystcfxmm">
          Built centrally once, activated in every market, governed from one
          viewpane.
        </p>
      </div>
    </div>;
}